// Standard library imports
import React from 'react';
// External library imports
import { Form, Formik } from 'formik';
// Internal module imports
import classes from '../../../styles/CapacityContent.module.css';
import Table from '../../../components/Table/Table';
import TabsComponent from '../../../components/Tabs/Tabs';
import { TextArea } from '../../../components/Inputs/Input';
import ovenClasses from '../Index.module.css';

const getCapacityPriceData = (request = {}, market) => {
    const { capacity = [], price = [], regulationPrice = [] } = request;
    const data = capacity.map((n, i) => {
        const slot = i + 1;
        return {
            slot,
            hour: `${i}-${slot}`,
            price: price[i],
            capacity: n,
            ...(market?.includes('aFRR') || market?.includes('mFRR') ? { regulationPrice: regulationPrice[i] } : {}),
        };
    });
    return data;
};

const RequestOverview = ({ market, request, setOpen }) => {
    const capacityPriceData = getCapacityPriceData(request, market);
    const tableHeaders = ['Slot', 'Hour', 'Capacity', 'Price'];
    const tableKey = ['slot', 'hour', 'capacity', 'price'];
    if (market?.includes('aFRR') || market?.includes('mFRR')) {
        tableHeaders.push('Energy Price');
        tableKey.push('regulationPrice');
    }
    const tabs = [
        {
            name: 'Capacity/Price',
            component: (
                <div style={{ maxHeight: '50vh', overflowY: 'scroll', padding: '0.5vw', width: '40vw' }}>
                    {request?.customBidding && <Table head={tableHeaders} keys={tableKey} data={capacityPriceData} />}

                    <div>
                        <Formik
                            initialValues={{
                                note: request?.note || '',
                            }}
                            enableReinitialize
                        >
                            {({ errors, touched, values, isValidating, ...props }) => (
                                <Form>
                                    <div className={ovenClasses.FieldControl}>
                                        <label for="note">Note</label>
                                        <TextArea name={`note`} label="Note" disabled={true} />
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            ),
        },
    ];
    return (
        <div>
            <TabsComponent tabs={tabs} />
            <div className={classes.ButtonContainer2}>
                <div className="btn-secondary" onClick={() => setOpen(false)}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default RequestOverview;
